import script from "./channelList.vue?vue&type=script&setup=true&lang=js"
export * from "./channelList.vue?vue&type=script&setup=true&lang=js"

import "./channelList.vue?vue&type=style&index=0&id=04742883&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04742883"]])

export default __exports__